import './Dashboard.css'
import { PieChart,pieArcLabelClasses } from '@mui/x-charts';
import { Box, Typography } from '@mui/material';
import Table from "../../components/utilities/table/Table";
import TableHead from "../../components/utilities/table/TableHead";
import TableBody from "../../components/utilities/table/TableBody";
import TransparentPageLayout from "../../layout/page-layout/TransparentPageLayout";
import FlexBox from "../../components/utilities/FlexBox";
import {Button} from "react-bootstrap";

import Noplans from "../../assets/dashboard/noplans.png";
import NoPendingData from "../../assets/dashboard/NoPendingDataAmb.svg";
import NoTestsMobile from "../../assets/dashboard/noTestsMobile.svg";
import NoPieData from "../../assets/dashboard/NoPieDataV1.png";
import GradeMobileIcon from "../../assets/dashboard/gradeMobile.svg";
import DateMobileIcon from "../../assets/dashboard/dataMobile.svg";
import ViewAllArrow from "../../assets/dashboard/viewAllArrow.svg";
import DsqMobileIcon from '../../assets/tests-list/dsqMobileIcon.svg';
import Loader from "../../components/utilities/Loader";
import {useContext, useEffect, useState} from "react";
import TableRow from "../../components/utilities/table/TableRow";
import axios from "axios";
import {CustomErrorToast, CustomToastContainer} from "../../components/utilities/CustomToast";
import {getCandidateFullName, getUrlParameter} from "../../utilities/Utilities";
import GradientButton from "../../components/utilities/gradient-button/GradientButton";
import {API_URL_PREFIX, APP_URL_PREFIX} from "../../utilities/Constants";
import CompanyTeamContext from "../../CompanyTeamContext";
import {Link, useNavigate} from "react-router-dom";
import Tooltip from "../../components/utilities/Tooltip";
import {getTestName, isLiveTestOrQuiz} from "../test/tests-list/TestsList";
import { Filter } from 'react-bootstrap-icons';
import ReactTooltip from 'react-tooltip';
import DisqualifiedIcon from '../../assets/candidate-profile/DisqualifiedIcon.svg';



const Dashboard = () => {
    const company = useContext(CompanyTeamContext) || {};
    const navigate = useNavigate()
    const navigation = useNavigate();
    const [selectedTab, setSelectedTab] = useState('completed');

    useEffect(()=>{
        if (getUrlParameter('url')) {
            let url = getUrlParameter('url');

            if(url.includes("?")){
                let parts = url.split("?")
                const goToPage = () => {
                    navigate({
                        pathname: parts[0],
                        search: parts[1],
                    });
                }
                goToPage();
            }
            else{
                navigation(getUrlParameter('url'))
            }

        }

        if(company){
            document.title  = "Dashboard - " + (company.basicTitle ? company.basicTitle : "Lugo-Test")
            return () => {
                document.title = company.basicTitle
            }
        }
    },[company])

    // Hide tooltips on scroll and touch for mobile
    useEffect(() => {
        const hideTooltip = () => {
            ReactTooltip.hide();
        };

        window.addEventListener('scroll', hideTooltip, true);
        window.addEventListener('touchstart', hideTooltip);
        window.addEventListener('touchmove', hideTooltip);

        return () => {
            window.removeEventListener('scroll', hideTooltip, true);
            window.removeEventListener('touchstart', hideTooltip);
            window.removeEventListener('touchmove', hideTooltip);
        };
    }, [])
    

    if(!company || !company.selectedLitePlan){
        return (
            <TransparentPageLayout height={"100%"}>
                <FlexBox justify={"start"} direction={"column"} style={{width:"100%", height:"700px"}}>
                    <p style={{fontFamily:"Nunito Sans", fontSize:"40px",backgroundColor: "",fontWeight:"bold",
                        color: "#000"}}>Choose Your Plan to Start Sending Tests</p>
                        <p style={{fontFamily:"", fontSize:"18px",color: "#181059",
                            opacity: "68%"}}>Access powerful tools to evaluate candidates, track results, and streamline your hiring process.</p>
                    <img src={Noplans} />                    
                    <Button style={{width:"154px",height:"44px",transition:"background 1s",background:"#774cf3",borderColor:"#784df4",fontSize:"18px",fontFamily:"Nunito Sans",radius:"12px"}} variant={"primary"}  onClick={e=>navigate(APP_URL_PREFIX +"/billing")}>View Plans</Button>
                </FlexBox>
            </TransparentPageLayout>
        )
    }





    return (<TransparentPageLayout>
        <CustomToastContainer/>

        {/* Desktop Layout */}
        <FlexBox className="dashboard-desktop" style={{height: "100%", width: "100%"}} align={"start"}>
            <FlexBox style={{width: "40%", marginRight: "25px", maxHeight: "100%"}} direction={"column"}>
            <CandidateStatusPieChart />
                <br/>
                <RecentExpiredTests/>
                {/*<TestsQuota />*/}
            </FlexBox>

            <FlexBox style={{width: "60%", marginRight: "25px", maxHeight: "100%"}} direction={"column"}>
                <RecentResults/>
                <br/>
                <RecentPendingQuizzes/>
            </FlexBox>
        </FlexBox>

        {/* Mobile Layout */}
        <FlexBox className="dashboard-mobile" style={{display: "none", height: "100%", width: "100%", flexDirection: "column"}} align={"start"}>
            <ReactTooltip className="dashboard-mobile-tooltip" multiline place="top" type="dark" effect="solid" />
            {/* Pie Chart */}
            <CandidateStatusPieChart />

            {/* Recent Tests Section with Tabs */}
            <div style={{width: "100%", marginTop: "20px"}}>
                <FlexBox justify={"space-between"} align={"center"} style={{marginBottom: "15px"}}>
                    <h3 style={{fontWeight: "700", color: "#364454", fontSize: "20px", margin: 0}}>Recent Tests</h3>
                    <Link
                        style={{fontSize: "13px", textDecoration: "underline", color: "#774CF3", display: "flex", alignItems: "center", gap: "5px"}}
                        to={APP_URL_PREFIX + `/quiz/list/${selectedTab}`}
                    >
                        View All
                        <img src={ViewAllArrow} alt="arrow" />
                    </Link>
                </FlexBox>

                {/* Tabs */}
                <FlexBox className="mobile-tabs" justify={"start"} style={{gap: "10px", marginBottom: "15px"}}>
                    <button
                        className={`tab-button ${selectedTab === 'completed' ? 'active' : ''}`}
                        onClick={() => setSelectedTab('completed')}
                    >
                        Completed
                    </button>
                    <button
                        className={`tab-button ${selectedTab === 'pending' ? 'active' : ''}`}
                        onClick={() => setSelectedTab('pending')}
                    >
                        Pending
                    </button>
                    <button
                        className={`tab-button ${selectedTab === 'expired' ? 'active' : ''}`}
                        onClick={() => setSelectedTab('expired')}
                    >
                        Expired
                    </button>
                </FlexBox>

                {/* Tab Content */}
                {selectedTab === 'completed' && <RecentResults hideTitle={true} />}
                {selectedTab === 'pending' && <RecentPendingQuizzes hideTitle={true} />}
                {selectedTab === 'expired' && <RecentExpiredTests hideTitle={true} />}
            </div>
        </FlexBox>

    </TransparentPageLayout>)

}
export default Dashboard



  const CandidateStatusPieChart = () => {

    const [chartData, setChartData] = useState([]);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // Handle window resize
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Fetch data from the API
    useEffect(() => {
      const fetchChartData = async () => {
        try {
          const response = await axios.get(API_URL_PREFIX+'/GetLast30DaysStats.html');
          const [completed, pending, expired] = response.data;

          const data = [];

          if (parseInt(completed, 10) > 0) {
            data.push({ id: 0, label: 'Completed', value: parseInt(completed, 10), color: '#774cf3', filter: 'completed' });
          }
          if (parseInt(pending, 10) > 0) {
            data.push({ id: 1, label: 'Pending', value: parseInt(pending, 10), color: '#b9aafd', filter: 'pending' });
          }
          if (parseInt(expired, 10) > 0) {
            data.push({ id: 2, label: 'Expired', value: parseInt(expired, 10), color: '#979DA5', filter: 'expired' });
          }

          // Update state with the new chart data
          setChartData(data);
            } catch (error) {
          console.error('Error fetching chart data:', error);
        }
      };

      fetchChartData();
    }, []);

    // Responsive chart dimensions
    const chartWidth = isMobile ? 320 : 600;
    const chartHeight = isMobile ? 280 : 300;
    const centerX = isMobile ? 160 : 180;
    const centerY = isMobile ? 120 : 145;
    const outerRadius = isMobile ? 100 : 136;
    const innerRadius = isMobile ? 30 : 40;


    return (
      <Box
        className="pie-chart-container"
        sx={{
          backgroundColor: '#fff',
          padding: 2,
          borderRadius: '16px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
          width: '100%',
          maxWidth: 600,
          margin: '0 auto',
        }}
      >
        <Typography
          variant="h6"
          component="h3"
          sx={{ marginBottom: 2, fontWeight: '700',color: '#364454',  fontSize: '20px' ,fontFamily: 'Nunito Sans'}}
        >
          Test Status - Last 30 Days
        </Typography>


          {chartData.length > 0 ? (
                <PieChart
                    series={[{
                        data: chartData,
                        innerRadius: innerRadius,
                        outerRadius: outerRadius,
                        paddingAngle: 2,
                        cx: centerX,
                        cy: centerY,
                        arcLabel: (item) => `${item.value}`,
                    }]}
                    width={chartWidth}
                    height={chartHeight}
                    onItemClick={(event, item) => {
                        const slice = chartData[item.dataIndex];
                        const filter = slice?.filter;
                        navigate(filter ? `/quiz/list/${filter}` : '/quiz/list');
                    }}

                    slotProps={{
                        legend: {
                        direction: isMobile ? 'row' : 'column',
                        position: isMobile ? { vertical: 'bottom', horizontal: 'middle' } : { vertical: 'top', horizontal: 'right' },
                        padding: isMobile ? 0 : 100,
                        },
                    }}
                    sx={{
                        [`& .${pieArcLabelClasses.root}`]: {
                        fill: "#ffffff",
                        fontWeight: 'normal',
                        fontFamily: 'Nunito Sans',
                        fontSize: '22px',
                        },
                        // '& .MuiPieChart-arc': {
                        // cursor: 'pointer'
                        // },
                        // cursor: 'default'
                    }}
                />
        	) : (
        		<div
        		  style={{
        		    display: "flex",
        		    flexDirection: "column",
        		    justifyContent: "center",
        		    alignItems: "center",
        		    paddingTop: "50px",
        		    paddingBottom: "50px",
        		    height: "300px",
        		    boxSizing: "border-box"
        		  }}
        		>
        		  <img
        		    src={NoPieData}
        		    alt="No Pie Chart Data"
        		    style={{ maxHeight: "220px", marginBottom: "12px" }}
        		  />
        		  <div style={{ color: "#888", fontSize: "16px", fontFamily: "Nunito Sans" }}>
        		    No Data Available Yet
        		  </div>
        		</div>
        	)}
      </Box>
    );
  };  

function RecentExpiredTests({label = "Recently Expired Tests", url = API_URL_PREFIX+"/GetRecentExpired.html", idName, hideTitle = false}) {
    const [quizzes, setQuizzes] = useState([])
    const [loaded, setLoaded] = useState(false)
    const company = useContext(CompanyTeamContext)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!company) return;
        if (quizzes && quizzes.length > 0) return;
        axios.get(url, {"Content-Type": "application/json"})
            .then(e => {
                setLoaded(true)
                let data = e.data;
                if (!data || data.err) {
                    CustomErrorToast(data.info)
                } else {
                    setQuizzes(data)
                    // Rebuild tooltips after content loads
                    setTimeout(() => ReactTooltip.rebuild(), 100);
                }
            })
            .catch(err => {
                setLoaded(true)
                CustomErrorToast("Error loading " + label.toLowerCase())
                console.log(err)
            })
    }, [company])

    // Rebuild tooltips when quizzes change
    useEffect(() => {
        if (quizzes.length > 0) {
            setTimeout(() => ReactTooltip.rebuild(), 100);
        }
    }, [quizzes])


    return (<div className={"container soft-shadow"}
                 style={{
                     width: "100%", padding: "20px", backgroundColor: '#fff', borderRadius: "16px", boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
                 }}>
        <FlexBox style={{marginBottom: "10px"}} justify={"space-between"} align={"start"} direction={"column"}>
            {!hideTitle && <FlexBox justify={"space-between"} style={{
                lineHeight: "20px", color: "#364454", fontWeight: "700", fontSize: "20px", width: "100%"
            }}>
                <div style={{width: "70%"}}>{label}</div>
                {quizzes.length > 0 && (
                    <Link style={{
                        lineHeight: "0",
                        fontSize: "13px",
                        textAlign: "right",
                        width: "30%",
                        textDecoration: "none",
                        color: "#774CF3"
                    }} to={APP_URL_PREFIX + "/quiz/list/expired"}>View All</Link>
                )}
            </FlexBox>}
            {!hideTitle && <br/>}
            <CustomToastContainer/>
            <div style={{width: "100%",height: "287px", overflow: "auto"}}>
                {loaded ? (
                    quizzes.length > 0 ? (
                        isMobile ? (
                            // Mobile card view
                            <div style={{width: "100%"}}>
                                {quizzes.map(q => {
                                    let score;
                                    let scoreColor = "#28A745"; // Green
                                    let scoreStatus = null; // For DSQ or STOPPED badge
                                    let scoreStatusTooltip = null; // Tooltip text for DSQ/STOPPED

                                    const disqualifyReasons = {
                                        1: "Disqualified: Failure to stay on the test tab.",
                                        2: "Disqualified: Print screen action detected during the test.",
                                        3: "Disqualified: Screen sharing was stopped during the test.",
                                        4: "Disqualified: Unauthorized use of AI tools detected.",
                                        5: "Disqualified: Unauthorized use of AI tools detected.",
                                        6: "Disqualified: Unauthorized use of Developer tools detected.",
                                    };

                                    if (q.quizScore == -1) {
                                        // Disqualified or stopped - show "--" with status
                                        score = "--";
                                        if (q.disqualificationStatus >= 1 && q.disqualificationStatus <= 6) {
                                            scoreStatus = "DSQ";
                                            scoreStatusTooltip = disqualifyReasons[q.disqualificationStatus];
                                            scoreColor = "#FF3B30"; // Red for disqualified
                                        } else {
                                            scoreStatus = "STOPPED";
                                            scoreColor = "#FF9500"; // Orange for stopped
                                        }
                                    } else if (q.quizScore >= 0) {
                                        // Has a valid score
                                        score = Math.floor(q.quizScore) + "%";

                                        if (q.disqualificationStatus >= 1 && q.disqualificationStatus <= 6) {
                                            // Restored but still disqualified
                                            scoreStatus = "DSQ";
                                            scoreStatusTooltip = disqualifyReasons[q.disqualificationStatus];
                                            scoreColor = "#FF3B30";
                                        } else if (q.disqualificationStatus > 6) {
                                            // Restored but stopped
                                            scoreStatus = "STOPPED";
                                            scoreColor = "#FF9500";
                                        } else {
                                            // Normal score
                                            if (q.quizScore < 60) {
                                                scoreColor = "#DC3545"; // Red for failed
                                            }
                                        }
                                    } else {
                                        // No score
                                        score = "--";
                                        scoreColor = "#6c757d"; // Gray
                                    }

                                    return (
                                        <div className="mobile-test-card completed" key={q.candidateKey + q.testKey}>
                                            <div className="mobile-test-card-top">
                                                <div style={{display: "flex", flexDirection: "column", gap: "3vw", flex: 1}}>
                                                    <div style={{display: "flex", flexDirection: "row", gap: "2vw", alignItems: "center"}}>
                                                        <span className="mobile-test-card-top-label">Test Name</span>
                                                        <span className="mobile-test-card-top-value">{getTestName(q, 20)}</span>
                                                    </div>
                                                    <div style={{display: "flex", flexDirection: "row", gap: "2vw", alignItems: "center"}}>
                                                        <span className="mobile-test-card-top-label">Assigned to</span>
                                                        <Link className="mobile-test-card-top-value" to={APP_URL_PREFIX + "/candidate/" + q.candidateKey} style={{textDecoration: "none"}}>{q.candidateName}</Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mobile-test-card-divider"></div>
                                            <div className="mobile-test-card-bottom">
                                                {!isLiveTestOrQuiz(q) && (
                                                    <div
                                                        className="mobile-test-card-bottom-item"
                                                        data-tip={scoreStatusTooltip || "Test score (0–100)"}
                                                    >
                                                        <img src={GradeMobileIcon} alt="Grade" />
                                                        <span className="mobile-test-card-bottom-value" style={{color: scoreColor}}>{score}</span>
                                                        {scoreStatus && (
                                                            <span style={{
                                                                marginLeft: '2vw',
                                                                fontSize: '3vw',
                                                                fontWeight: '600',
                                                                color: scoreColor,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '1vw'
                                                            }}>
                                                                {scoreStatus}
                                                                {scoreStatus === "DSQ" && <img src={DsqMobileIcon} alt="DSQ" style={{width: '3vw', height: '3vw'}} />}
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                                <div className="mobile-test-card-bottom-item" style={{marginLeft: 'auto'}} data-tip="Expired Date">
                                                    <img src={DateMobileIcon} alt="Date" />
                                                    <span className="mobile-test-card-bottom-value">{new Date(q.expireDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            // Desktop table view
                            <Table id={idName}
                                style={{width: "100%", maxHeight: "400px", minHeight: "80px", overflow: "auto", marginBottom: "0"}}>
                                <TableHead columns={["", "Name", "Test name"]}></TableHead>
                                <TableBody style={{textAlign: "center"}}>
                                    {quizzes.map(q => <TableRow
                                            style={{textAlign: "left", color: "#636E7B", height: "40px"}}>
                                            <td style={{width: "30px"}}></td>
                                            <td  ><Link className={"candidate-link"}
                                            to={APP_URL_PREFIX + "/candidate/" + q.candidateKey}>{q.candidateName}</Link></td>
                                            <td>{q.predefinedTest ? <span >{getTestName(q, 32)}</span> :
                                                <Link className={"candidate-link"} to={APP_URL_PREFIX + "/test/" + q.testKey}>{getTestName(q, 32)}</Link>}</td>
                                        </TableRow>)}
                                </TableBody>
                            </Table>
                        )
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
                            <img src={isMobile ? NoTestsMobile : NoPendingData} alt="No Expired Data" style={{ maxHeight: "160px", marginBottom: "10px" }} />
                            No Recent Expired Tests
                        </div>
                    )
                ) : <Loader loader={!loaded}/>
                }
            </div>
        </FlexBox>

    </div>);
}

function RecentResults({hideTitle = false}) {

    const [quizzes, setQuizzes] = useState([])
    const [loaded, setLoaded] = useState(false)
    const company = useContext(CompanyTeamContext)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (quizzes && quizzes.length > 0) return;
        if (!company) return;
        axios.get(API_URL_PREFIX+"/GetRecentResults.html")
            .then(e => {
                setLoaded(true)
                let data = e.data;
                if (!data || data.err) {
                    CustomErrorToast(data.info)
                } else {
                    setQuizzes(data.sort((a,b)=> {
                        return b.quizDate - a.quizDate;
                    }))
                    // Rebuild tooltips after content loads
                    setTimeout(() => ReactTooltip.rebuild(), 100);
                }
            })
            .catch(err => {
                setLoaded(true)
                CustomErrorToast("Error loading recent results.")
                console.log(err)
            })
    }, [company])

    // Rebuild tooltips when quizzes change
    useEffect(() => {
        if (quizzes.length > 0) {
            setTimeout(() => ReactTooltip.rebuild(), 100);
        }
    }, [quizzes])


    return (<div className={"container soft-shadow"}
                 style={{
                     width: "100%", maxHeight: "50%", overflow: "auto", padding: "20px", backgroundColor: '#fff', borderRadius: "16px", boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
                 }}>
        <FlexBox style={{marginBottom: "10px"}} justify={"space-between"} align={"start"} direction={"column"}>
            {!hideTitle && <FlexBox justify={"space-between"} style={{
                lineHeight: "20px", color: "#364454", fontWeight: "700", fontSize: "20px", width: "100%"
            }}>
                <div style={{width: "100%"}}>Recently Completed Tests</div>
                {quizzes.length > 0 && (
                    <Link style={{
                        lineHeight: "0",
                        fontSize: "13px",
                        textAlign: "right",
                        width: "100%",
                        textDecoration: "none",
                        color: "#774CF3"
                    }} to={APP_URL_PREFIX + "/quiz/list/completed"}>View All</Link>
                )}
            </FlexBox>}
            {!hideTitle && <br/>}
            <div style={{width: "100%",height:"287px", overflow: "auto"}}>
                {loaded ? (
                    quizzes.length > 0 ? (
                        isMobile ? (
                            // Mobile card view
                            <div style={{width: "100%"}}>
                                {quizzes.map(q => {
                                    let score;
                                    let scoreColor = "#28A745"; // Green
                                    let scoreStatus = null; // For DSQ or STOPPED badge
                                    let scoreStatusTooltip = null; // Tooltip text for DSQ/STOPPED

                                    const disqualifyReasons = {
                                        1: "Disqualified: Failure to stay on the test tab.",
                                        2: "Disqualified: Print screen action detected during the test.",
                                        3: "Disqualified: Screen sharing was stopped during the test.",
                                        4: "Disqualified: Unauthorized use of AI tools detected.",
                                        5: "Disqualified: Unauthorized use of AI tools detected.",
                                        6: "Disqualified: Unauthorized use of Developer tools detected.",
                                    };

                                    if (q.quizScore == -1) {
                                        // Disqualified or stopped - show "--" with status
                                        score = "--";
                                        if (q.disqualificationStatus >= 1 && q.disqualificationStatus <= 6) {
                                            scoreStatus = "DSQ";
                                            scoreStatusTooltip = disqualifyReasons[q.disqualificationStatus];
                                            scoreColor = "#FF3B30"; // Red for disqualified
                                        } else {
                                            scoreStatus = "STOPPED";
                                            scoreColor = "#FF9500"; // Orange for stopped
                                        }
                                    } else if (q.quizScore >= 0) {
                                        // Has a valid score
                                        score = Math.floor(q.quizScore) + "%";

                                        if (q.disqualificationStatus >= 1 && q.disqualificationStatus <= 6) {
                                            // Restored but still disqualified
                                            scoreStatus = "DSQ";
                                            scoreStatusTooltip = disqualifyReasons[q.disqualificationStatus];
                                            scoreColor = "#FF3B30";
                                        } else if (q.disqualificationStatus > 6) {
                                            // Restored but stopped
                                            scoreStatus = "STOPPED";
                                            scoreColor = "#FF9500";
                                        } else {
                                            // Normal score
                                            if (q.quizScore < 60) {
                                                scoreColor = "#DC3545"; // Red for failed
                                            }
                                        }
                                    } else {
                                        // No score
                                        score = "--";
                                        scoreColor = "#6c757d"; // Gray
                                    }

                                    return (
                                        <div className="mobile-test-card completed" key={q.candidateKey + q.quizDate}>
                                            <div className="mobile-test-card-top">
                                                <div style={{display: "flex", flexDirection: "column", gap: "3vw", flex: 1}}>
                                                    <div style={{display: "flex", flexDirection: "row", gap: "2vw", alignItems: "center"}}>
                                                        <span className="mobile-test-card-top-label">Test Name</span>
                                                        <span className="mobile-test-card-top-value">{getTestName(q, 20)}</span>
                                                    </div>
                                                    <div style={{display: "flex", flexDirection: "row", gap: "2vw", alignItems: "center"}}>
                                                        <span className="mobile-test-card-top-label">Assigned to</span>
                                                        <Link className="mobile-test-card-top-value" to={APP_URL_PREFIX + "/candidate/" + q.candidateKey} style={{textDecoration: "none"}}>{q.candidateName}</Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mobile-test-card-divider"></div>
                                            <div className="mobile-test-card-bottom">
                                                {!isLiveTestOrQuiz(q) && (
                                                    <div
                                                        className="mobile-test-card-bottom-item"
                                                        data-tip={scoreStatusTooltip || "Test score (0–100)"}
                                                    >
                                                        <img src={GradeMobileIcon} alt="Grade" />
                                                        <span className="mobile-test-card-bottom-value" style={{color: scoreColor}}>{score}</span>
                                                        {scoreStatus && (
                                                            <span style={{
                                                                marginLeft: '2vw',
                                                                fontSize: '3vw',
                                                                fontWeight: '600',
                                                                color: scoreColor,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '1vw'
                                                            }}>
                                                                {scoreStatus}
                                                                {scoreStatus === "DSQ" && <img src={DsqMobileIcon} alt="DSQ" style={{width: '3vw', height: '3vw'}} />}
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                                <div className="mobile-test-card-bottom-item" style={{marginLeft: 'auto'}} data-tip="Last Modified">
                                                    <img src={DateMobileIcon} alt="Date" />
                                                    <span className="mobile-test-card-bottom-value">{new Date(q.quizDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            // Desktop table view
                            <Table
                                style={{width: "100%", maxHeight: "231px", minHeight: "80px", overflow: "auto", marginBottom: "0"}}>
                                <TableHead columns={["", "Candidate Name", "Test name", <FlexBox justify={"start"} style={{height:"100%"}}>Score&nbsp;<Tooltip text={"Score out of 100"} /></FlexBox>, "Date"]}></TableHead>
                                <TableBody style={{textAlign: "center"}}>
                                    {quizzes.map(q => {
                                        let score = q.quizScore;
                                        score = (score ? Math.floor(score): score)+"%";
                                        if (q.quizScore == -1) {
                                            if ("1" == (q.disqualificationStatus)) {
                                                score =  ( <Tooltip text={"Disqualified: Failure to stay on the test tab."}>
                                                <span className="disqualified-frame">
                                                <span className="disqualified-text-wrapper">DSQ</span>
                                                <img
                                                    className="disqualified-vector"
                                                    alt="DisqualifiedIcon"
                                                    src={DisqualifiedIcon}
                                                />
                                                </span>
                                                </Tooltip> );
                                            } else if ("2" == (q.disqualificationStatus)) {
                                                score = (
                                                        <Tooltip text={"Disqualified: Print screen action detected during the test."}>
                                                        <span className="disqualified-frame">
                                                        <span className="disqualified-text-wrapper">DSQ</span>
                                                        <img
                                                            className="disqualified-vector"
                                                            alt="DisqualifiedIcon"
                                                            src={DisqualifiedIcon}
                                                        />
                                                        </span>
                                                    </Tooltip>
                                                );
                                            } else if("3"==(q.disqualificationStatus)){
                                                score = (
                                                            <Tooltip text={"Disqualified: Screen sharing was stopped during the test."}>
                                                                <span className="disqualified-frame">
                                                                <span className="disqualified-text-wrapper">DSQ</span>
                                                                <img
                                                                    className="disqualified-vector"
                                                                    alt="DisqualifiedIcon"
                                                                    src={DisqualifiedIcon}
                                                                />
                                                                </span>
                                                            </Tooltip>
                                                        );
                                            } else if("4"==(q.disqualificationStatus) || "5"==(q.disqualificationStatus) ){
                                                score = (
                                                        <Tooltip text={"Disqualified: Unauthorized use of AI tools detected."}>
                                                        <span className="disqualified-frame">
                                                        <span className="disqualified-text-wrapper">DSQ</span>
                                                        <img
                                                            className="disqualified-vector"
                                                            alt="DisqualifiedIcon"
                                                            src={DisqualifiedIcon}
                                                        />
                                                        </span>
                                                    </Tooltip>
                                                );
                                            } else if("6"==(q.disqualificationStatus)){
                                                score = (
                                                        <Tooltip text={"Disqualified: Unauthorized use of Developer tools detected."}>
                                                        <span className="disqualified-frame">
                                                        <span className="disqualified-text-wrapper">DSQ</span>
                                                        <img
                                                            className="disqualified-vector"
                                                            alt="DisqualifiedIcon"
                                                            src={DisqualifiedIcon}
                                                        />
                                                        </span>
                                                    </Tooltip>
                                                );
                                            } else {
                                                score = (
                                                	<span className="stopped-button-frame">
                                                        <span className="stopped-button-text-wrapper">STOPPED</span>
                                                    </span>
                                                ); 
                                            }
                                        }

                                        return <TableRow style={{textAlign: "left", color: "#636E7B", height: "40px"}}>
                                            <td style={{width: "30px"}}></td>
                                            <td  ><Link className={"candidate-link"}
                                                to={APP_URL_PREFIX + "/candidate/" + q.candidateKey}>{q.candidateName}</Link></td>
                                            <td>{q.predefinedTest ? <span >{getTestName(q, 40)}</span> :
                                                <Link className={"candidate-link"} to={APP_URL_PREFIX + "/test/" + q.testKey}>{getTestName(q, 40)}</Link>}</td>
                                            <td>{isLiveTestOrQuiz(q) ? '': score}</td>
                                            <td>{new Date(q.quizDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</td>
                                        </TableRow>;
                                    })}
                                </TableBody>
                            </Table>
                        )
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img src={isMobile ? NoTestsMobile : NoPendingData} alt="No Completed Data" style={{ maxHeight: "160px", marginBottom: "10px" }} />
                            No Recent Completed Tests
                        </div>
                    )
                ) : <Loader loader={!loaded}/>
                }
            </div>
        </FlexBox>

    </div>);
}

function RecentPendingQuizzes({hideTitle = false}) {

    const [quizzes, setQuizzes] = useState([])
    const [loaded, setLoaded] = useState(false)
    const company = useContext(CompanyTeamContext)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (quizzes && quizzes.length > 0) return;
        if (!company) return;
        axios.get(API_URL_PREFIX+"/GetRecentPendingQuizzes.html")
            .then(e => {
                setLoaded(true)
                let data = e.data;
                if (!data || data.err) {
                    CustomErrorToast(data.info)
                } else {
                    setQuizzes(data.sort((a,b)=> {
                        return b.quizDate - a.quizDate;
                    }))
                    // Rebuild tooltips after content loads
                    setTimeout(() => ReactTooltip.rebuild(), 100);
                }
            })
            .catch(err => {
                setLoaded(true)
                CustomErrorToast("Error loading recent pending tests.")
                console.log(err)
            })
    }, [company])

    // Rebuild tooltips when quizzes change
    useEffect(() => {
        if (quizzes.length > 0) {
            setTimeout(() => ReactTooltip.rebuild(), 100);
        }
    }, [quizzes])

    return (<div className={"container soft-shadow"}
                 style={{
                     width: "100%", maxHeight: "50%", overflow: "auto", padding: "20px", backgroundColor: '#fff', borderRadius: "16px", boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
                 }}>
        <FlexBox style={{marginBottom: "10px", width: "100%"}} justify={"space-between"} align={"start"}
                 direction={"column"}>
            {!hideTitle && <FlexBox justify={"space-between"} style={{
                lineHeight: "20px", color: "#364454", fontWeight: "700", fontSize: "20px", width: "100%"
            }}>
                <div style={{width: "100%"}}>Recently Pending Tests</div>
                {quizzes.length > 0 && (
                    <Link style={{
                        lineHeight: "0",
                        fontSize: "13px",
                        textAlign: "right",
                        width: "100%",
                        textDecoration: "none",
                        color: "#774CF3"
                    }} to={APP_URL_PREFIX + "/quiz/list/pending"}>View All</Link>
                )}
            </FlexBox>}
            {!hideTitle && <br/>}            
            <div style={{width: "100%",height:"287px", overflow: "auto", textAlign: "center"}}>
                {loaded ? (
                    quizzes.length > 0 ? (
                        isMobile ? (
                            // Mobile card view
                            <div style={{width: "100%"}}>
                                {quizzes.map(q => (
                                    <div className="mobile-test-card completed" key={q.candidateKey + q.quizDate}>
                                        <div className="mobile-test-card-top">
                                            <div style={{display: "flex", flexDirection: "column", gap: "3vw", flex: 1}}>
                                                <div style={{display: "flex", flexDirection: "row", gap: "2vw", alignItems: "center"}}>
                                                    <span className="mobile-test-card-top-label">Test Name</span>
                                                    <span className="mobile-test-card-top-value">{getTestName(q, 15)}</span>
                                                </div>
                                                <div style={{display: "flex", flexDirection: "row", gap: "2vw", alignItems: "center"}}>
                                                    <span className="mobile-test-card-top-label">Assigned to</span>
                                                    <Link className="mobile-test-card-top-value" to={APP_URL_PREFIX + "/candidate/" + q.candidateKey} style={{textDecoration: "none"}}>{q.candidateName}</Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mobile-test-card-divider"></div>
                                        <div className="mobile-test-card-bottom">
                                            {!isLiveTestOrQuiz(q) && (
                                                <div
                                                    className="mobile-test-card-bottom-item"
                                                    data-tip="Test score (0–100)"
                                                >
                                                    <img src={GradeMobileIcon} alt="Grade" />
                                                    <span className="mobile-test-card-bottom-value" style={{color: "#6c757d"}}>--</span>
                                                </div>
                                            )}
                                            <div className="mobile-test-card-bottom-item" style={{marginLeft: 'auto'}} data-tip="Date Sent">
                                                <img src={DateMobileIcon} alt="Date" />
                                                <span className="mobile-test-card-bottom-value">{new Date(q.quizDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            // Desktop table view
                            <Table
                                style={{width: "100%", maxHeight: "235px", minHeight: "80px", overflow: "auto", marginBottom: "0"}}>
                                <TableHead columns={["", "Candidate Name", "Test name", "Sent at"]}></TableHead>
                                <TableBody style={{textAlign: "center"}}>
                                    {quizzes.map(q => <TableRow
                                            style={{textAlign: "left", color: "#636E7B", height: "40px"}}>
                                            <td style={{width: "30px"}}></td>
                                            <td  ><Link className={"candidate-link"}
                                                to={APP_URL_PREFIX + "/candidate/" + q.candidateKey}>{q.candidateName}</Link></td>
                                            <td>{q.predefinedTest ? <span >{getTestName(q, 40)}</span> :
                                                <Link className={"candidate-link"} to={APP_URL_PREFIX + "/test/" + q.testKey}>{getTestName(q, 40)}</Link>}</td>
                                            <td>{new Date(q.quizDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</td>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        )
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <img src={isMobile ? NoTestsMobile : NoPendingData} alt="No Assigned Data" style={{ maxHeight: "160px", marginBottom: "10px" }} />
                            No Recent Assigned Tests
                        </div>
                    )
                ) : <Loader loader={!loaded}/>
                }
            </div>
            
        </FlexBox>

    </div>);
}